'use strict';

window.replaceImage = function replaceImage(img) {
    var element = document.getElementById('imgnotfound');
    if (element) {
        var $img = $(img);
        var srcNotFound = element.src;

        $img.attr('src', srcNotFound);
        $img.attr('data-srcset', srcNotFound);
        $img.attr('srcset', srcNotFound);
    }
};
